// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".menu-transition-enter-active[data-v-a29d57c6]{transition-duration:.3s;transition-timing-function:ease-in}.menu-transition-leave-active[data-v-a29d57c6]{transition-duration:.3s;transition-timing-function:cubic-bezier(0,1,.5,1)}.menu-transition-enter-to[data-v-a29d57c6],.menu-transition-leave[data-v-a29d57c6]{left:0;overflow:hidden}.menu-transition-enter[data-v-a29d57c6],.menu-transition-leave-to[data-v-a29d57c6]{left:-100%;overflow:hidden}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
